import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IKindVersion } from '../model/kind/KindVersion';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useSpecificationsForKindsResult {
    isLoaded: boolean;
    specificationKinds: IKindVersion[] | null;
}

export const useSpecificationsForKinds = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const [result, setResult] = useState<useSpecificationsForKindsResult>({ isLoaded: false, specificationKinds: [] });

    useEffect(() => {
        setResult({ isLoaded: false, specificationKinds: [] });

        rootStore.specificationsForKindsStore.loadSpecifications()
            .then(() => {
                setResult({ isLoaded: true, specificationKinds: rootStore.specificationsForKindsStore.getKinds() });
            })
            .catch(e => publishNotification({
                text: `Error loading specifications kinds: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.specificationsForKindsStore, publishNotification, rootStore.gameVersionStore.currentGameVersion]);

    return result;
};
